import en from './en';
import zhCn from './zh-cn';
import zhTw from './zh-tw';

export default {
  en,
  'zh-cn': zhCn,
  'zh-tw': zhTw,
};



// WEBPACK FOOTER //
// ./src/i18n/index.js